import React from "react";
import { connect } from "react-redux";
import Role from "../components/System/Role";

function RolePage({ accessToken, currentLang }) {
  return <Role accessToken={accessToken} currentLang={currentLang} />;
}

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(RolePage);
